import React, {useState} from "react";
import logo from "../assets/logo.svg";
import Footer from "../components/Footer/footer.js";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { getLoginData } from "../services/profile-service.js";
import { useAuth } from "../utils/authContext.js";

const Login = () => {
    const navigate = useNavigate();
    const { checkAuth } = useAuth();
    const [error, setError] = useState("");
    const [inputValues, setInputValues] = useState({
        input1: "",
        input2: "",
        input3: "",
        input4: ""
    });

    const {
        register,
        handleSubmit
    } = useForm({
        mode: "onChange",
    });

    const handleInputChange = (e, index) => {
        const { value } = e.target;
        const digit = value.slice(-1).match(/\d/);

        if (error) {
            setError('');
        }

        setInputValues((prevValues) => ({
            ...prevValues,
            [`input${index}`]: digit || "",
        }));

        if (digit && index < 4) {
            const nextInput = document.getElementById(`input${index + 1}`);
            if (nextInput) nextInput.focus();
        }


    };

    const onSubmit = async () => {
        const otp = Object.values(inputValues).join("");
        try {
            await getLoginData(otp);
            // Update auth context to fetch chef data
            await checkAuth(true);
            // Navigate after auth context is updated
            navigate("/orders");
        } catch (error) {
            setError("Սխալ կոդ, փորձեք կրկին");
            setInputValues({ input1: "", input2: "", input3: "", input4: "" });

            const firstInput = document.getElementById(`input1`);
            if (firstInput) firstInput.focus();
        }
    };

    const isFormValid = Object.values(inputValues).every(value => value !== "");

    const handleFocus = (e) => {
        e.target.select();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (!inputValues[`input${index}`] && index > 1) {
                const prevInput = document.getElementById(`input${index - 1}`);
                if (prevInput) prevInput.focus();
            }

            setInputValues((prevValues) => ({
                ...prevValues,
                [`input${index}`]: "",
            }));
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const splitData = e.clipboardData.getData("text")
            .replace(/\D/g, '')
            .match(/\d/g);;
        if (splitData) {
            const newInputValues = {};
            splitData.forEach((digit, i) => {
                newInputValues[`input${i + 1}`] = digit;
            });
            setInputValues((prevValues) => ({
                ...prevValues,
                ...newInputValues,
            }));

            const nextField = document.getElementById(
                `input${splitData.length < 4 ? splitData.length + 1 : 4}`
            );
            if (nextField) nextField.focus();
        }
    };

    return (
        <div>
            <div className="flex">
                <img src={logo || ''} alt="logo" className="mb-6 mx-auto mt-3 w-32 h-11"/>
            </div>
            <div className="flex justify-center mt-60 mb-64">
                <div className="m-10">
                    <p className="text-black text-center text-xl mb-4 font-bold leading-relaxed">Մուտք գործել</p>
                    <p className="text-base mb-4 text-start leading-loose font-medium">
                        1. Անցեք
                        <a
                            href="https://t.me/bychef_assistant_bot"
                            target="_blank"
                            rel="noreferrer"
                            className="text-base font-medium border-b-2 border-black"
                        >
                            {" "} այս {" "}
                        </a>
                        հղումով դեպի Telegram
                    </p>
                    <p className="text-black text-base mb-4 text-start leading-loose font-medium">2. Մուտքագրեք <b>/login</b> հրամանը եթե արդեն գրանցվել եք, հակառակ դեպքում <b>/start</b> հրամանը</p>
                    <p className="text-black text-base mb-4 text-start leading-loose font-medium">3. Ստացեք կոդը և մուտաքգրեք այն աստեղ</p>
                    <div className="flex justify-center items-center text-center">
                        <form onSubmit={handleSubmit(onSubmit)} noValidate>
                            <div className="flex justify-center gap-4 mb-4">
                                {[1, 2, 3, 4].map((index) => (
                                    <input
                                        key={index}
                                        {...register(`input${index}`)}
                                        id={`input${index}`}
                                        type="text"
                                        value={inputValues[`input${index}`] || ""}
                                        onFocus={handleFocus} // Enable temporary editing
                                        onChange={(e) => handleInputChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        onPaste={handlePaste} // Handle pasting
                                        maxLength={1}
                                        className={`w-12 h-12 text-center border rounded-md text-xl focus:ring-2 focus:ring-gray-500 focus:outline-none ${
                                            error ? "border-red-500" : "border-gray-300"
                                        }`}
                                        style={{
                                            caretColor: "transparent"
                                        }}
                                        autoComplete="off"
                                        inputMode="numeric"
                                        aria-label={`OTP Input ${index}`}
                                    />
                                ))}
                            </div>

                            {error && <p className="text-red-500 text-sm" style={{marginBottom: 10}}>{error}</p>}
                            <button
                                className={`w-full ${isFormValid ? 'bg-black' : 'bg-gray-500'} text-white py-2 px-6 rounded-lg font-medium`}
                                type="submit"
                                disabled={!isFormValid}
                            >
                                Մուտք գործել
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default Login;
